import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { InputDatePicker } from "@/components/elements/InputDatePicker";
import { Select } from "@/components/elements/Select";
import { TSupportContractForm } from "@/features/anytime/types/supportContractForm";
import { Grid } from "@mui/material";
import { FC } from "react";
import { useFormContext } from "react-hook-form";

type TTerminationForm = {
  readonly?: boolean;
};

export const TerminationForm: FC<TTerminationForm> = ({ readonly }) => {
  const { control } = useFormContext<TSupportContractForm>();

  return (
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <FormField control={control} name="modifyContractDate">
          <InputDatePicker readonly={readonly} />
        </FormField>
      </Grid>
      <Grid item xs={8} />
      <Grid item xs={12}>
        <FormField control={control} name="modifyContractReason">
          <Select enumName="ESupportContractSubcategoryReason" readonly={readonly} />
        </FormField>
      </Grid>
      <Grid item xs={12}>
        <FormField control={control} name="modifyContractContent">
          <Input readonly={readonly} />
        </FormField>
      </Grid>
    </Grid>
  );
};
